import * as L from 'leaflet';

const poiMapping = {
  "lvsCheck": "beaconcheck",
  "lvsSearch": "beaconsearch",
  "wlan": "wlan",
  "dropzone": "dangerous",
  "noExit": "noexit",
  "webcam": "webcam",
  "parks": "park",
  "frInfo": "freerideinfo",
  "restaurant": "restaurant",
  "rodln": "rodeln",
  "wildschutz": "wild",
  "gletscherspalte": "crevasse",
  "noreturn": "noreturn",
  "track": "skier"
};

const getDangerIcon = function (props) {
  var ico = "icon-" + poiMapping[props.type];
  // console.log("icon props: ", props);
  if (props && props.myTrack) {
    return L.divIcon({
      className: 'freerideinfo myTrack freerideinfoWarning ' + ico
    });
  }
  if (props.tourtype === "powderDepartment") { // partner
    return L.icon({
      iconUrl: "/map/img/logo/powderDepartment.png",
      iconSize: [50, 36],
      className: "powderDepartment freerideinfoWarning"
    });
  }
  return L.divIcon({
    iconSize: [34, 32],
    className: ico + ' freerideinfo freerideinfoWarning'
  });
};


class Pois {

  map;
  featureGroup;
  loadedPois = [];

  constructor(map, featureGroup) {
    this.map = map;
    this.featureGroup = featureGroup;
  }

  async loadPois() {
    const zoom = this.map.getZoom();
    if (zoom <= 11) {
      this.loadedPois = [];
      this.featureGroup.clearLayers();
      return;
    }
    const b = this.map.getBounds();
    const data = await fetch(`/sh/poisonly/${b.getWest()}/${b.getSouth()}/${b.getEast()}/${b.getNorth()}`);
    const dataJ = await data.json();
    this.mkPoiMarker(dataJ);
    // console.log('your markers; "', markers);
    // this.featureGroup.addLayer(markers);
    // return markers;
  }

  mkPoiMarker(data) {
    let myMarker, wcImage;
    // console.log('gjdata: ', data);
    const l = new L.GeoJSON(data, {
      pointToLayer: (data, latlng) => {
        if (this.loadedPois.indexOf(data._id) >= 0) {
          return;
        }
        if (data.properties && data.properties.type === "track") {
          return;
        } else if (data.properties && data.properties.type === "webcam") {
          myMarker = new L.Marker(latlng);
          var pop = new L.Popup({
            offset: [0, -30],
            className: "wcPopup"
          });
          // console.log("WEBCAM: ", data.properties);
          if (data.properties.player) {
            wcImage = `<a target='_wc_window' href='${data.properties.player}'> 
              <img class='webcamIcon' src='${data.properties.thumbnail}&amp;t=38' alt='webcam' ></a>`;
          } else {
            wcImage = `<img class='webcamIcon' src='${data.properties.thumbnail}' alt='webcam' >`;
          }
          pop.setContent(`<div class='wcContainer'>${wcImage}</div>`);
          myMarker.bindPopup(pop);
        } else if (data.properties && data.properties.type) {
          myMarker = new L.Marker(latlng, {
            icon: getDangerIcon(data.properties)
          });
        }
        return myMarker;
      },
      onEachFeature: (ft, layer) => {
        if (this.loadedPois.indexOf(ft._id) >= 0) {
          return;
        }
        // console.log('adding layer to group: ', layer, ft);
        layer.properties = ft.properties;
        layer._id = ft._id;
        layer.setIcon(getDangerIcon(ft.properties));
        this.featureGroup.addLayer(layer);
        this.loadedPois.push(ft._id);
      }
    });
    // console.log('all markers from geojson: ', l);
    return l;
  }
}

const PoiLayer = L.FeatureGroup.extend({
  onAdd: async function (map) {
    const pois = new Pois(map, this);
    pois.loadPois();
    map.on("moveend", () => {
      pois.loadPois();
    })
  },
});

export { PoiLayer, Pois };
